const common: Record<string, string> = {
  // Nav
  "nav.explore": "Explore",
  "nav.discuss": "Discuss",
  "nav.projects": "Products",
  "nav.post": "Post",
  "nav.login": "Sign in",
  "nav.join": "Join",
  "nav.search": "Search",
  "nav.searchPlaceholder": "Jump to a handle, e.g. yixian",
  "nav.searchEmpty": "Enter a user handle (yixian or @yixian)",
  "nav.searchSoon": "Full-text search is coming. Handles open profiles; hyphenated slugs try product pages",
  "nav.searchGoExplore": "Browse products in Explore",
  "nav.notifications": "Notifications",
  "nav.profile": "Profile",

  // Masthead (site cover)
  "masthead.tagline": "Creator experience × Customer experience",
  "masthead.deck": "In dev.cx, cx stands for customer experience — both the experience developers have using this community, and the experience real customers have with the products built here. No echo chambers, no navel-gazing.",
  "masthead.colophonLabel": "This week",
  "masthead.prevWeekly": "Last issue ",
  "masthead.readWeekly": "Read",
  // Home anonymous join cue — one prose sentence, links in flow (not a · list)
  "home.joinLeadSoft": "Invite-only for now.",
  "home.joinInviteLink": "Join with a code",
  "home.joinOr": ", or ",
  "home.joinWaitlistLink": "leave your email for the waitlist",
  "home.joinEnd": ".",
  // Footer quieter secondary exits
  "home.joinFooterInvite": "Join",
  "home.joinFooterWaitlist": "Waitlist",
  "masthead.colBuilders": "builders",
  "masthead.colProducts": "products",
  "masthead.colDiscussions": "discussions",
  "masthead.statsBuilders": "builders active",
  "masthead.statsProjects": "products",
  "masthead.statsDiscussions": "discussions",

  // Masthead (now compact weekly banner)
  "weekly.bannerLabel": "Digest",
  "weekly.bannerViewFull": "View full digest →",
  "weekly.bannerPrev": "Previous",
  "weekly.bannerNext": "Next",

  // Focus (now hero)
  "focus.heading": "This Week's Focus",
  "focus.deck": "Projects and discussions the community is working on this week.",
  "focus.statsBuilders": "builders active",
  "focus.statsProjects": "products",
  "focus.statsDiscussions": "discussions",
  "focus.label": "Focus",
  "focus.sublabel": "This Week",
  "focus.mastheadLabel": "Community Focus",
  "focus.mastheadDeck": "Ranked by discussion activity — the most active works and discussions in the community this week.",
  // Home Focus chapter criterion (API sort=trending = reply heat, last 7 days)
  "focus.rankingHint": "Ranked by reply activity over the last 7 days — not hand-picked by editors.",
  "focus.feedback": "Seeking feedback",
  "focus.trending": "Trending",
  "focus.viewAll": "All products",
  "focus.viewAllCount": "All {{count}} products",

  // Discussion chapter
  "discussion.label": "Discussion",
  "discussion.sublabel": "In Discussion",
  "discussion.replies": "replies",
  "discussion.more": "More",
  "discussion.viewAll": "View all discussions",
  "discussion.sortLatest": "Latest",
  "discussion.sortHottest": "Hottest",

  // Profile
  "profile.status.building": "BUILDING",
  "profile.status.learning": "LEARNING",
  "profile.status.hiring": "HIRING",
  "profile.status.open": "OPEN",
  "profile.follow": "Follow",
  "profile.following": "Following",
  "profile.share": "Share",
  "profile.shareCopied": "Link copied",
  "profile.shareFailed": "Copy failed — paste from the address bar",
  "profile.thisWeek": "This Week",
  "profile.updatedAt": "Updated",
  "profile.works": "Products",
  "profile.activity": "Activity",
  "profile.about": "About",
  "profile.followers": "Followers",
  "profile.noProjects": "Pin what you're building",
  "profile.noProjectsHint": "Your profile is visible to the community",
  "profile.viewAll": "View all",
  "profile.publicUrl": "Public profile",
  "profile.locationLabel": "Location",
  "profile.companyLabel": "Status",
  "profile.linksLabel": "Links",
  "profile.noActivity": "No activity yet",
  "profile.noActivityHint": "Activity will appear here after publishing or updating projects",

  // Project
  "project.demo": "Demo",
  "project.repo": "Repo",
  "project.docs": "Docs",
  "project.writeProgress": "Write update",
  "project.postShow": "Post Show",
  "project.timeline": "Timeline",
  "project.discuss": "Discuss",
  "project.discuss.filterAll": "All",
  "project.discuss.filterFeedback": "Feedback",
  "project.feedback": "Feedback",
  "project.feedback.submit": "Submit feedback",
  "project.feedback.submitTitle": "Submit Feedback",
  "project.feedback.titleLabel": "Title",
  "project.feedback.titlePlaceholder": "Briefly describe your feedback…",
  "project.feedback.needTitle": "Please add a feedback title",
  "project.feedback.needBody": "Please write the feedback body",
  "project.feedback.descriptionLabel": "Description",
  "project.feedback.descriptionPlaceholder": "The more specific, the more likely it gets addressed…",
  "project.feedback.sortNewest": "Newest",
  "project.feedback.sortReplies": "Most replies",
  "project.feedback.cancel": "Cancel",
  "project.feedback.submitSuccess": "Feedback submitted. Thanks for contributing.",
  "project.feedback.submitError": "Submission failed. Please try again later.",
  "project.feedback.submitting": "Submitting…",
  "project.feedback.merge": "Merge",
  "project.feedback.mergeSelected": "Merge selected",
  "project.feedback.mergeHint": "Select similar threads to merge — then pick which one stays as the main discussion.",
  "project.feedback.mergeTitle": "Merge Discussions",
  "project.feedback.mergeDescription": "Pick one thread to keep as the main discussion. The rest will be absorbed into it. Typically the one with the most replies is the best candidate.",
  "project.feedback.mergeConfirm": "Confirm merge",
  "project.feedback.mergedFrom": "Merged from",
  "project.feedback.mergedFromCount": "Merged {{count}} discussions",
  "project.feedback.emptyHint": "Feedback comes from community discussions. Tag your post with a feedback type when publishing.",
  "project.feedback.postFeedback": "Post feedback",
  "project.feedback.lockedTitle": "Post Feedback",
  "project.feedback.lockedDeck": "Your feedback will be linked to {{project}} and published as a discussion.",
  "project.feedback.filterAll": "All",
  "project.feedback.sortUpvotes": "Most upvoted",
  "project.feedback.empty": "No matching feedback",
  "project.follow": "Follow",
  "project.following": "Following",
  "project.editProject": "Edit Product",
  "project.audience.endUsers": "End users",
  "project.audience.developers": "Developers",
  "project.audience.teams": "Teams & companies",
  "project.audienceFacing": "For {{audience}}",
  "project.about": "About",
  "project.createdBy": "Created by",
  "project.publicUrl": "Product URL",
  "project.publishedDays": "Published {{days}} days ago",
  "project.metaUpdated": "updated {{time}}",
  "project.metaFounded": "started {{date}}",
  "project.locale": "en-US",

  // New Project
  "newProject.title": "Create Product",
  "newProject.deck": "A complete product page so the community can understand what you're building",
  "newProject.deckCompact": "Name and URL are enough to create — polish the rest later.",
  "newProject.requiredHint": "* required · rest optional",
  "newProject.optionalSection": "About / tags / links / shots (optional)",
  "newProject.expandOptional": "Show optional",
  "newProject.collapseOptional": "Hide optional",
  "newProject.optionalCollapsedHint": "Description, tags, links, and screenshots can wait.",
  "newProject.formIncomplete": "Some required fields are missing or invalid. Fix them, then try again.",
  "newProject.formIncompleteCount": "{{count}} items need attention — use the list below.",
  "newProject.jumpToError": "Jump to first issue",
  "project.formIncomplete": "Some required fields are missing or invalid. Fix them, then try again.",
  "project.formIncompleteCount": "{{count}} items need attention — use the list below.",
  "project.jumpToError": "Jump to first issue",
  "project.backToProduct": "Back to product",
  "newProject.cancel": "Cancel",
  "newProject.create": "Create Product",
  "newProject.creating": "Creating...",
  "newProject.successTitle": "Product Created",
  "newProject.successDesc": "Your product page is ready",
  "newProject.viewProject": "View Product",
  "newProject.createAnother": "Create Another",

  // Compose
  "compose.title": "Compose",
  "compose.deck": "Publish with quality. Every post deserves to be taken seriously.",
  "compose.chooseType": "Choose type",
  "compose.show": "Show",
  "compose.showSubtitle": "Share product results, get feedback",
  "compose.build": "Build",
  "compose.buildSubtitle": "Log what you built this week",
  "compose.ask": "Discuss",
  "compose.askSubtitle": "Ask questions, share opinions, start discussions — connect developers and community",
  "compose.discuss": "Discuss",
  "compose.discussSubtitle": "Ask questions, share opinions, start discussions — connect developers and community",

  "compose.project": "Linked product",
  "compose.projectDesc": "Select an existing product, or create one",
  "compose.projectPlaceholder": "Search products…",
  "compose.projectSearch": "Search products…",
  "compose.noProjectMatch": "No matching product",
  "compose.newProject": "New product",
  "compose.newProjectName": "Product name",
  "compose.newProjectHint": "New product will be linked to this post",
  "compose.titleField": "Title",
  "compose.titlePlaceholder": "An eye-catching title…",
  "compose.oneLiner": "One-liner",
  "compose.oneLinerPlaceholder": "Summarize the core highlight in one sentence",
  "compose.body": "Body",
  "compose.bodyPlaceholder": "Write your thoughts, process, results…",
  "compose.sectionContent": "Content",
  "compose.contentDesc": "Title, one-liner, and body",
  "compose.sectionShowcase": "Showcase",
  "compose.showcaseDesc": "Stage and external links",
  "compose.sectionFeedback": "Feedback guidance",
  "compose.feedbackDesc": "Guide the community to give you the feedback you want",
  "compose.links": "Links",
  "compose.addLink": "Add link",
  "compose.linkLabel": "Label",
  "compose.linkLabelShort": "Label",
  "compose.linkUrl": "URL",
  "compose.linkUrlShort": "URL",
  "compose.confirm": "Confirm",
  "compose.cancel": "Cancel",
  "compose.feedbackWanted": "Feedback wanted",
  "compose.feedbackOptional": "optional — one tap",
  "compose.feedbackHint": "Put the specific question in the body — the thread page shows these tags in its feedback band.",
  "compose.feedbackChip.correctness": "Correctness",
  "compose.feedbackChip.performance": "Performance",
  "compose.feedbackChip.uiux": "UI / UX",
  "compose.feedbackChip.copy": "Copywriting",
  "compose.feedbackAddCustom": "+ Custom",
  "compose.typeKeepHint": "switch anytime, content stays",
  "compose.projectRequired": "required",
  "compose.projectNone": "None",
  "compose.viewPost": "View post",
  "compose.lockedBuildTitle": "Post an update",
  "compose.lockedBuildDeck": "This update will land on the timeline of {{project}}.",
  "compose.lockedShowTitle": "Share results",
  "compose.lockedShowDeck": "Show the community the latest from {{project}}.",
  "compose.addFeedbackChip": "Add feedback type",
  "compose.uncertainties": "Uncertainties",
  "compose.addUncertainty": "Add uncertainty",

  "compose.done": "Done",
  "compose.doneDesc": "What did you finish this week worth recording",
  "compose.donePlaceholder": "What did you finish this week…",
  "compose.blockers": "Blockers",
  "compose.blockersDesc": "What obstacles are you facing",
  "compose.blockersPlaceholder": "What got in the way…",
  "compose.next": "Next",
  "compose.nextDesc": "What do you plan to push forward next",
  "compose.nextPlaceholder": "What are you planning next…",

  "compose.tags": "Tags",
  "compose.tagsPlaceholder": "Type tag, press Enter to add",
  "compose.askTitlePlaceholder": "Describe your question concisely…",
  "compose.askDesc": "Describe your question in detail, including context, attempted solutions, and expected outcome",

  "compose.saveDraft": "Save draft",
  "compose.savingDraft": "Saving…",
  "compose.loadingDraft": "Loading draft…",
  "compose.draftNotEditable": "This post is not an editable draft",
  "compose.draftNeedsProject": "Pick a product before drafting Show / Build",
  "compose.editNotAllowed": "Edit window closed or others have replied",
  "compose.saveEdit": "Save changes",
  "compose.saveAndView": "Save & view",
  "thread.edited": "edited",
  "thread.edit": "Edit",
  "compose.preview": "Preview",
  "compose.needTitle": "Please add a title",
  "compose.needBody": "Please write the body",
  "compose.needProjectToPublish": "Show / Build posts must be linked to a product",
  "compose.needProjectCreateFirst": "You have no products yet. Create one before publishing Show / Build.",
  "compose.needEmailVerify": "Verify your email before publishing — check your inbox, or resend from the top banner",
  "compose.noProjectsYet": "You have no products yet. Create one before posting Show / Build.",
  "compose.createProjectFirst": "Create a product →",
  "compose.publish": "Publish",
  "compose.publishing": "Publishing...",
  "compose.published": "Published",
  "compose.publishedDesc": "Your content has been published to the community",
  "compose.viewFeed": "View discussions",
  "compose.copyProfile": "Copy profile",
  "compose.copySummary": "Copy summary",
  "compose.newPost": "New post",
  "compose.autoSaved": "Saved at {time}",
  "compose.showTitlePlaceholder": "Give your showcase a title...",
  "compose.buildTitlePlaceholder": "Build log title...",
  "compose.buildBodyPlaceholder": "Write your build log — what you built, what blocked you, next steps…",
  "compose.discussTitlePlaceholder": "Give your discussion a title...",
  "compose.discussBodyPlaceholder": "Share an interesting product, ask a question, or start a community discussion — drop links and share your thoughts.",
  "compose.discussProjectLabel": "Start a discussion for {{name}}",
  "compose.removeProject": "Remove product",

  // Theme
  "theme.warm": "Warm",
  "theme.light": "Light",
  "theme.dark": "Dark",

  // Thread
  "thread.breadcrumb.show": "Show",
  "thread.breadcrumb.build": "Build",
  "thread.breadcrumb.discuss": "Discuss",
  "thread.links": "Product Reference",
  "thread.noLinks": "Standalone post · No product",
  "thread.feedbackWanted": "Feedback wanted",
  "thread.uncertainties": "Uncertainties",
  "thread.sort": "Sort",
  "thread.sortLatest": "Latest",
  "thread.sortEarliest": "Earliest",
  "thread.report": "Report",
  "thread.reply": "Reply",
  "thread.authorBadge": "Author",
  "thread.sendReply": "Post reply",
  "thread.sending": "Sending…",
  "thread.needBody": "Write something before posting",
  "thread.replyLogin": "Sign in to reply",
  "thread.replyPlaceholder": "Write your thoughts…",
  "thread.replyTo": "Reply to #{floor}",
  "thread.send": "Send",
  "thread.cancel": "Cancel",
  "thread.replyCount": "replies",
  "thread.floor": "#{floor}",
  "thread.expandChildren": "Expand {count} replies",
  "thread.collapseChildren": "Collapse",
  "thread.loadMore": "Load more replies",
  "thread.allRepliesLoaded": "All replies loaded",
  "thread.composerCollapsed": "Write a reply…",
  "thread.mergedFromBanner": "Merged {{count}} related discussions",
  "thread.mergedInto": "This discussion has been merged into:",
  "thread.hiddenLabel": "HIDDEN",
  "thread.hiddenPost": "This content has been hidden for violating community guidelines",
  "thread.hiddenReasonLabel": "Reason",
  "thread.hiddenOwnBanner": "This content is hidden — visible only to you and moderators",
  "thread.hiddenReply": "This reply has been hidden",
  "thread.hiddenReplyOwn": "This reply is hidden (visible to you and moderators)",

  // Admin inline moderation (Task 9)
  "admin.inlineLabel": "OP",
  "admin.reasonPrompt": "Reason (shown on the tombstone):",
  "admin.deletePrompt": "Hard-delete reason (illegal content only; irreversible):",
  "admin.hidePost": "Hide post",
  "admin.unhidePost": "Unhide post",
  "admin.hide": "hide",
  "admin.unhide": "unhide",
  "admin.delete": "delete",

  // Admin ops desk /admin (Task 10)
  "admin.title": "Ops Desk",
  "admin.userSection": "User actions",
  "admin.auditSection": "Audit log",
  "admin.auditEmpty": "No moderation actions yet",
  "admin.handlePlaceholder": "Look up user by handle",
  "admin.lookup": "Look up",
  "admin.userNotFound": "No such user",
  "admin.warnCount": "Warnings",
  "admin.mutedUntil": "Muted until",
  "admin.suspendedAt": "Suspended at",
  "admin.warn": "Warn",
  "admin.warnPrompt": "Warning message (delivered as in-app notification):",
  "admin.mute": "Mute (7d default)",
  "admin.unmute": "Unmute",
  "admin.suspend": "Suspend account",
  "admin.suspendPrompt": "Suspension reason (user will be unable to log in):",
  "admin.unsuspend": "Restore account",
  "admin.loadMore": "Load more",

  // Admin settings & invites (Task 19)
  "admin.settingsSection": "System settings",
  "admin.settingsHint": "Resolution order: database first, env fallback. Secrets are write-only; changes take effect immediately. SMTP expects 587/STARTTLS (implicit-TLS 465 unsupported).",
  "admin.settingsSMTP": "SMTP (mail channel)",
  "admin.settingsOAuth": "GitHub OAuth",
  "admin.settingsSave": "Save",
  "admin.settingsResetBtn": "Reset to env",
  "admin.settingsSaved": "Saved, effective immediately",
  "admin.settingsReset": "Reverted to environment variable",
  "admin.secretSet": "Configured (write-only)",
  "admin.secretUnset": "Not configured",
  "admin.smtpTestBtn": "Send test email",
  "admin.smtpTestOK": "Test email sent",
  "admin.smtpTestFail": "Send failed: check config or api logs",
  "admin.invitesSection": "Invite codes",
  "admin.invitesNotePlaceholder": "Batch note (e.g. w32-batch)",
  "admin.invitesMint": "Mint",
  "admin.invitesVoid": "Void",
  "admin.invitesLinkHint": "Share the register link; it opens onboarding with the invite code filled in (/onboarding?code=…).",
  "admin.invitesFreshTitle": "Just minted (copy links to share)",
  "admin.invitesCopyLink": "Copy link",
  "admin.invitesCopyAllLinks": "Copy all links",
  "admin.invitesLinkCopied": "Copied",
  "admin.waitlistCount": "Waitlist",

  // Onboarding
  "onboarding.inviteApplied": "Invite code applied",
  "onboarding.handleHint": "Your page will live at dev.cx/@handle; your display name defaults to it and can be changed later in Edit Profile",
  "onboarding.displayName": "Display name",
  "onboarding.displayNamePlaceholder": "Your name",
  "onboarding.handle": "Handle",
  "onboarding.handlePlaceholder": "your-handle",
  "onboarding.bio": "Bio",
  "onboarding.bioPlaceholder": "Brief intro — what you do, what you're interested in…",
  "onboarding.status": "Status",
  "onboarding.statusBuilding": "Building",
  "onboarding.statusExploring": "Exploring",
  "onboarding.statusPaused": "Paused",
  "onboarding.statusSupporting": "Supporting",
  "onboarding.projectNamePlaceholder": "What's your product called",
  "onboarding.projectDeckPlaceholder": "What does this product do",
  "onboarding.projectStage": "Stage",
  "onboarding.projectLink": "Link (optional)",
  "onboarding.projectLinkPlaceholder": "GitHub or other link",

  // Feed / Explore
  "feed.title": "Latest",
  "feed.allDiscussions": "All discussions",
  "feed.totalDiscussions": "{{count}} discussions",
  "feed.all": "All",
  "feed.show": "Show",
  "feed.build": "Build",
  "feed.discuss": "Discuss",
  "feed.today": "Today",
  "feed.yesterday": "Yesterday",
  "feed.thisWeek": "Earlier this week",
  "feed.noResults": "No content yet",
  "feed.loadMore": "Load more",

  "explore.title": "Explore",
  "explore.label": "Explore",
  "explore.allProducts": "All products",
  "explore.totalProducts": "{{count}} products",
  "explore.mastheadDate": "2026 · July",
  "explore.indexTitle": "Product Index",
  "explore.issueCount": "This issue includes {{count}} products",
  "explore.sectionLabel": "Section",
  "explore.filterStage": "Stage",
  "explore.filterAll": "All",
  "explore.stageAll": "All",
  "explore.sort": "Sort",
  "explore.sortTrending": "Trending",
  "explore.sortLatest": "Latest",
  "explore.latest": "Latest",
  "explore.views": "views",
  "explore.topic": "Topic",
  "explore.noResults": "No products yet",
  "explore.loadMore": "Load more",

  // Footer
  "footer.improve": "Improve your profile",
  "footer.joinCue": "Invite-only · Join with a code · Waitlist",
  "footer.loginPrompt": "Sign in required",
  "footer.loginPromptDesc": "You need to sign in to improve your profile. Go to login?",
  "footer.goLogin": "Sign in",
  "footer.cancel": "Cancel",
  "footer.login": "Sign in to dev.cx",
  "footer.about": "About",
  "footer.guidelines": "Guidelines",
  "footer.report": "Report",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",

  // Mobile tabs
  "mobile.discover": "Discover",
  "mobile.latest": "Discuss",
  "mobile.post": "Post",
  "mobile.join": "Join",
  "mobile.notifications": "Alerts",
  "mobile.me": "Me",

  // About
  "about.title": "About dev.cx",
  "about.deck": "A product-driven creator community with no gatekeeping by tools or identity. Code by hand, prompt with AI — what matters is that you're building.",
  "about.whyTitle": "Why we built it",
  "about.why.p1": "Creator conversations scatter across messaging groups, social apps, and closed communities. Information is fragmented and lacks context — you discuss a product for three days in a chat, and three days later it's gone forever.",
  "about.why.p2": "dev.cx anchors discussions to products. Every creator gets a public profile showing what you're building, your toolkit, and your thought process. It's not a resume — it's a living creative identity.",
  "about.pitch": "dev.cx is trying to do one thing: give every creator a proper place to seriously talk about what they're building — no matter your tools, no matter your background.",
  "about.principles.title": "Principles",
  "about.principles.p1": "Quality over quantity. The homepage refreshes curated picks once a week, not every minute.",
  "about.principles.p2": "Quiet editorial. No notification badges, no algorithmic feeds. You come here because you want to read something thoughtful.",
  "about.principles.p3": "Open and transparent. Guidelines, progress, and discussions are all public. dev.cx itself is built on dev.cx.",
  "about.principles.p4": "Your data is yours. Everything you publish here can be packed up and taken with you — sign in and export it from your settings.",
  "about.sealLabel": "dev.cx editorial",
  "about.contact.title": "Contact",
  "about.contact.p1": "Open source under AGPL-3.0 — contributions welcome. Questions — email us.",
  "about.email": "Email",
  "about.backToCommunity": "Back to community",
  "about.guidelinesLink": "Guidelines",
  "about.colophon.version": "Edition 1",
  "about.colophon.builtOn": "Built on",
  "about.colophon.year": "2026 · July",
  "about.colophon.typeset": "Typeset in",

  // Notifications
  "notifications.title": "Notifications",
  "notifications.today": "Today",
  "notifications.yesterday": "Yesterday",
  "notifications.thisWeek": "Earlier this week",
  "notifications.empty": "No notifications yet",
  "notifications.allRead": "All read",
  "notifications.unreadCount": "unread",
  "notifications.markAllRead": "Mark all as read",
  "notifications.typeMention": "MENTION",
  "notifications.typeReply": "REPLY",
  "notifications.typeFollow": "FOLLOW",
  "notifications.typeUpdate": "UPDATE",
  "notifications.typeModeration": "MOD",
  "notifications.mentionedYou": "mentioned you in a discussion",
  "notifications.repliedTo": "replied to your post",
  "notifications.followedYou": "followed you",
  "notifications.projectUpdate": "Product update",
  "notifications.moderationNotice": "sent you a moderation notice",
  "notifications.in": "in",

  // Me
  "me.title": "Settings",
  "me.editProfile": "Edit Profile",
  "me.myProjects": "My Products",
  "me.myPosts": "My Posts",
  "me.drafts": "Drafts",
  "drafts.deck": "Unpublished drafts — continue or delete.",
  "drafts.loginRequired": "Sign in to see your drafts",
  "drafts.loading": "Loading…",
  "drafts.empty": "No drafts yet",
  "drafts.write": "Write something",
  "drafts.untitled": "Untitled draft",
  "drafts.continue": "Continue",
  "drafts.delete": "Delete",
  "me.bookmarks": "Bookmarks",
  "me.settings": "Settings",
  "me.export": "Export my data (JSON)",
  "me.emailWeekly": "Weekly email",
  "me.emailWeeklyOn": "On",
  "me.emailWeeklyOff": "Off",
  "me.signOut": "Sign Out",
  "me.profilePreview": "Profile Preview",
  "me.changeAvatar": "Change Avatar",
  "me.copyProfileLink": "Copy Profile Link",
  "me.copied": "Copied",
  "me.publicProfile": "Public Profile",
  "me.quickActions": "Quick Actions",
  "me.account": "Account",
  "me.content": "Content",
  "me.misc": "Other",
  "me.statusUpdate": "Update Status",
  "me.quickProject": "Quick Create Product",
  "me.quickProjectDeck": "Just a product name is enough — fill in the rest later",
  "me.quickProjectCreate": "Create Product",
  "me.status.title": "Update Status",
  "me.status.deck": "Log your weekly progress so the community knows your rhythm",
  "me.status.fieldLabel": "This week",
  "me.status.placeholder": "What you did, what's blocking you, what's next… one line is fine",
  "me.status.save": "Update Status",
  "me.status.saving": "Saving...",
  "me.status.saved": "Status Updated",
  "me.status.savedDesc": "Your latest status is now visible on your profile",
  "me.status.viewProfile": "View Profile",
  "me.status.updateAgain": "Keep Editing",
  "me.profile.title": "Edit Profile",
  "me.profile.deck": "Display name, bio, and current status",
  "me.profile.save": "Save",
  "me.setup.title": "Set up your page",
  "me.setup.profile": "Write a short bio, pick a status",
  "me.setup.project": "Pin your first product",
  "me.setup.status": "Say hello — what are you working on?",
  "me.followedProjects": "Followed Products",

  // My Projects
  "myProjects.title": "My Products",
  "myProjects.count": "products",
  "myProjects.empty": "No products yet",
  "myProjects.noDeck": "No description",

  // Weekly magazine
  "weekly.title": "Week {week} Digest",
  "weekly.back": "← Back to Home",
  "weekly.comingSoon": "This week's digest is on its way",
  "weekly.weekNav": "Week {{week}}",
  "weekly.theme": "This Week's Theme",
  "weekly.editorNote": "Editor's Note",
  "weekly.highlights": "Weekly Picks",
  "weekly.projectHighlight": "Work",
  "weekly.discussionHighlight": "Discussion",
  "weekly.replies": "Reader Comments",
  "weekly.replyCount": "comments",
  "weekly.replyLoginHint": "Sign in to comment",
  "weekly.composerCollapsed": "Share your thoughts on this issue…",
  "weekly.replyPlaceholder": "Share your thoughts on this week's digest…",

  // Guidelines
  "guidelines.title": "Community Guidelines",
  "guidelines.deck": "dev.cx is a creator experience-first community. These guidelines keep our discussions high-quality and low-noise.",
  "guidelines.section1.title": "Content Quality",
  "guidelines.section1.p1": "Every post should carry value — whether it's project progress, a technical question, or a showcase. Avoid pure rants or content-free filler.",
  "guidelines.section1.p2": "Show posts need something viewable (demo link, screenshots, code repo). Build posts should record concrete progress, not 'didn't do much this week.' Discuss posts must describe context, attempted solutions, and expected outcomes clearly.",
  "guidelines.section2.title": "Discussion Etiquette",
  "guidelines.section2.p1": "Stay kind and respectful. Even when you disagree with someone's technical approach, focus on the approach, not the person.",
  "guidelines.section2.p2": "Read the post and existing replies before commenting. Avoid repeating answers to questions already discussed. If your reply extends a specific comment, use the reply-to-floor feature instead of a new top-level comment.",
  "guidelines.section3.title": "Feedback Culture",
  "guidelines.section3.p1": "When sharing a product, explicitly state what kind of feedback you want. This helps responders target their help more effectively.",
  "guidelines.section3.p2": "When giving feedback, be specific. Instead of 'great work,' say 'the API design is clean, but edge case handling could use more detail.'",
  "guidelines.section4.title": "Product-Driven",
  "guidelines.section4.p1": "All discussions in dev.cx revolve around products. Even technical Q&A should tie to a product you're actually working on.",
  "guidelines.section4.p2": "Your product page is your creator identity. Keep it updated — an abandoned page is just noise to the community.",
  "guidelines.section5.title": "Disputes & Moderation",
  "guidelines.section5.p1": "Violations (personal attacks, spam, malicious spamming, etc.) may result in content removal, warnings, or bans by moderators.",
  "guidelines.section5.p2": "If you believe your content was removed by mistake, you can appeal through the contact channels on the About page.",
  "guidelines.backToCommunity": "Back to community",

  // Privacy
  "privacy.title": "Privacy Policy",
  "privacy.deck": "dev.cx collects as little data as we can, and uses it only where it keeps the community running. This page explains what we collect, why, and the rights you have over your own data.",
  "privacy.section1.title": "collect",
  "privacy.section1.p1": "At sign-up: your email, your password (stored as a hash only), and the handle and display name you choose. With GitHub sign-in: only your GitHub login and email — we never request repository or any other permissions.",
  "privacy.section1.p2": "In use: the content you publish (projects, posts, replies, images), your follow relationships, and the basic access logs required to keep the service up. No ad tracking, no third-party analytics cookies — the only cookie is your login session.",
  "privacy.section2.title": "use",
  "privacy.section2.p1": "Your email is used for sign-in, verification, and on-site notifications (such as reply alerts). It is never used for marketing, and never sold or shared with third parties.",
  "privacy.section2.p2": "Access logs are used only for troubleshooting and abuse prevention (such as rate limiting). We do not build profiles.",
  "privacy.section3.title": "third parties",
  "privacy.section3.p1": "GitHub (OAuth sign-in, login and email only); img.li (image hosting — the images you upload are stored there); our self-hosted mail service (verification and notification emails).",
  "privacy.section3.p2": "Our servers are located outside mainland China. Public content you publish (profile, projects, posts) can be indexed by search engines — that is exactly what a linkable public archive is meant to be.",
  "privacy.section4.title": "your rights",
  "privacy.section4.p1": "You can export all of your content (as JSON) from the settings page at any time. This is a product promise, not just a compliance clause.",
  "privacy.section4.p2": "To delete your account, email report@dev.cx and we will process and confirm it within a reasonable time. If the service ever shuts down, we will give six months' notice and keep the export channel open (the graceful-exit clause).",
  "privacy.section5.title": "changes",
  "privacy.section5.p1": "Revisions are posted on this page with a date; major changes are announced on-site.",
  "privacy.section5.p2": "This policy was last updated on 2026-07-27. Questions? Write to report@dev.cx.",
  "privacy.backToCommunity": "Back to community",

  // Terms
  "terms.title": "Terms of Service",
  "terms.deck": "dev.cx is an invite-only community for creators. These terms try to speak plainly: your content is yours, the guidelines are serious, and we are upfront about what happens if this ever winds down.",
  "terms.section1.title": "account",
  "terms.section1.p1": "Registration requires an invitation code and email verification. Your account is yours to use and safeguard; actions taken under it are treated as yours.",
  "terms.section1.p2": "Your handle is your unique identity on the site. Renaming is allowed (about once every 90 days); the old handle permanently redirects to your new page and is never opened for registration.",
  "terms.section2.title": "your content",
  "terms.section2.p1": "You keep the copyright to everything you publish. You grant dev.cx the display and distribution rights needed to operate: showing your work on-site, generating weekly digests, and being indexed by search engines.",
  "terms.section2.p2": "You can export all of your content at any time. Once you delete content or your account, we stop displaying it; copies in backups expire naturally with the backup cycle.",
  "terms.section3.title": "conduct",
  "terms.section3.p1": "The written guidelines live at /guidelines. Red lines (illegal activity and scams, privacy violations, personal attacks, serious infringement) are enforced: hiding content (leaving a tombstone with the reason), warnings, time-limited mutes, or account suspension. Only illegal content is deleted outright.",
  "terms.section3.p2": "Every moderation action leaves an internal audit record. To appeal a decision, write to report@dev.cx.",
  "terms.section4.title": "handle policy",
  "terms.section4.p1": "Handles that impersonate someone (using a well-known name to imply you are them) can be reclaimed. Sharing a name is not impersonation — we reject the behavior, not the label.",
  "terms.section4.p2": "A pure placeholder handle that was never used (say, twelve months with zero content and a legitimate claim from someone else) may be recycled, with an email notice and a grace period first. Going quiet after being active is a legitimate state and will never be recycled.",
  "terms.section5.title": "service",
  "terms.section5.p1": "dev.cx is a long-term passion project. The service is provided as-is, with no availability guarantees. The operator is a builder too, and takes weeks off — red-line moderation stays covered even during quiet stretches.",
  "terms.section5.p2": "Three public promises: your data is exportable at any time; if we shut down, you get six months' notice and the export channel stays open; the spotlight (home page and weekly placements) is never for sale.",
  "terms.section6.title": "termination",
  "terms.section6.p1": "Serious or repeated violations lead to account suspension. You can also request deletion of your own account at any time (see the Privacy Policy).",
  "terms.section6.p2": "These terms were last updated on 2026-07-27. Continued use means acceptance of the current version; major changes are announced on-site.",
  "terms.backToCommunity": "Back to community",

  // 注册同意句。链接文本前后的空格与连接词放在文案里,JSX 会吞掉表达式之间的换行空白。
  "legal.consent": "By signing up you agree to the ",
  "legal.terms": "Terms of Service",
  "legal.and": " and the ",
  "legal.privacy": "Privacy Policy",

  // Login
  "login.kicker": "Account · Sign in",
  "login.title": "Sign in to dev.cx",
  "login.deck": "Sign in to post, reply, and build your developer profile",
  "login.registerTitle": "Join dev.cx",
  "login.registerDeck": "dev.cx is invite-only. You need a valid invitation code to register",
  "login.forgotTitle": "Reset Password",
  "login.forgotDeck": "Enter your registered email and we'll send a verification code",
  "login.email": "Email",
  "login.emailPlaceholder": "your@email.com",
  "login.password": "Password",
  "login.passwordPlaceholder": "Enter password",
  "login.passwordPlaceholderRegister": "At least 8 characters",
  "login.passwordHint": "Password must be at least 8 characters",
  "login.confirmPassword": "Confirm password",
  "login.confirmPasswordPlaceholder": "Re-enter password",
  "login.newPassword": "New password",
  "login.newPasswordPlaceholder": "Enter new password",
  "login.inviteCode": "Invitation Code",
  "login.inviteCodePlaceholder": "Enter your invitation code",
  "login.inviteHint": "Currently invite-only. If you don't have a code yet, follow our social media to get one.",
  "login.verificationCode": "Verification Code",
  "login.sendCode": "Send Code",
  "login.resendCode": "Resend",
  "login.sending": "Sending…",
  "login.codeSent": "Verification code sent, check your inbox",
  "login.submit": "Sign in",
  "login.registerSubmit": "Create account",
  "login.submitting": "Processing…",
  "login.forgotPassword": "Forgot password?",
  "login.resetPassword": "Reset password",
  "login.passwordResetSuccess": "Password reset. Redirecting to sign in…",
  "login.backToHome": "Back to Home",
  "login.backToLogin": "Back to sign in",
  "login.oauthHint": "Or continue with",
  "login.oauthComingSoon": "Coming soon",
  "login.oauthGitHubAria": "Continue with GitHub",
  "login.oauthGoogleAria": "Google sign-in coming soon — use GitHub or email for now",
  "login.oauthFootnote": "GitHub only for now; Google will light up here when ready",
  "login.errorRequired": "Please enter your email and password",
  "login.errorEmailRequired": "Please enter your email",
  "login.errorInviteRequired": "This GitHub account isn't linked to a dev.cx account yet — registration currently requires an invite.",
  "login.errorCodeRequired": "Please enter the verification code",
  "login.errorPasswordMismatch": "Passwords do not match",
  "login.errorPasswordShort": "Password must be at least 6 characters",
  "login.errorSendCode": "Failed to send verification code, please try again",
  "login.errorGeneric": "Sign in failed, please try again",
  "login.errorSuspended": "This account has been suspended. Contact report@dev.cx to appeal",
  "login.switchToRegister": "Don't have an account? Register with an invite →",
  "login.switchToLogin": "Already have an account? Sign in",

  // Me
  "me.loginRequiredTitle": "Sign in required",
  "me.loginRequiredDesc": "Sign in to view your profile, products, and notifications",

  // Notifications
  "notifications.loginRequiredTitle": "Sign in required",
  "notifications.loginRequiredDesc": "Sign in to view replies, mentions, and project updates",

  // PostList
  "postList.replies": "replies",
  "postList.prevPage": "Previous page",
  "postList.nextPage": "Next page",
  "postList.bookmark": "Bookmark",
  "postList.unbookmark": "Remove bookmark",

  // Project settings
  "project.settings": "Product Settings",
  "project.settingsSubtitle": "Manage basic info, links, tags, screenshots, etc.",
  "project.settingsSaved": "Saved",
  "project.saving": "Saving...",
  "project.saveSettings": "Save changes",
  "project.visibilitySection": "Visibility",
  "project.publicBadge": "Public",
  "project.hiddenBadge": "Unlisted",
  "project.publicHelp": "Visible on Explore and public profiles. Unlisting hides it from visitors.",
  "project.hiddenHelp": "Unlisted: only you can see it. It won’t appear on Explore or other people’s views of your profile. You can make it public again anytime.",
  "project.hideAction": "Unlist product",
  "project.unhideAction": "Make public again",
  "project.visibilityWorking": "Working…",
  "project.hiddenOwnerBanner": "This product is unlisted — visitors can’t see it.",
  "project.manageVisibility": "Manage visibility →",
  "project.basicInfo": "Basic Info",
  "project.namePlaceholder": "What's your product called",
  "project.tagline": "One-liner",
  "project.taglinePlaceholder": "Summarize what this product does in one sentence",
  "project.stage": "Current Stage",
  "project.audienceLabel": "Who is it for",
  "project.audienceHint": "Pick as many as apply; open-source libs, CLIs, SDKs → Developers. Not sure yet? Leave it empty — you can change it anytime.",
  "project.description": "Description",
  "project.descriptionPlaceholder": "Write a product description in Markdown: core features, problem solved, tech highlights, use cases…",
  "project.tagsPlaceholder": "Scenario, domain, or stack — press Enter to add",
  "project.links": "External Links",
  "project.tags": "Tags",
  "project.screenshots": "Screenshots",
  "project.noScreenshots": "No screenshots yet",
  "project.addScreenshot": "Add screenshot",
  "project.uploadScreenshot": "Upload image",
  "project.screenshotUrlPlaceholder": "Paste an image URL...",
  "project.add": "Add",
  "project.addLink": "Add link",
  "project.linkRemove": "Remove link",
  "project.linkLabelPlaceholder": "Label",
  "project.linkUrlPlaceholder": "https://...",
  "project.nameLabel": "Product name",
  "project.err.nameRequired": "Product name is required",
  "project.err.tooLong": "Too long (max {{max}} characters)",
  "project.err.tooMany": "Too many (max {{max}})",
  "project.err.tagTooLong": "Each tag can be at most {{max}} characters",
  "project.err.linkIncomplete": "A link needs both a label and a URL",
  "project.err.urlScheme": "URL must start with http:// or https://",
  "project.slugPlaceholder": "my-product",
  "project.slugHint": "Lowercase letters, digits and hyphens, 2–32 chars. This is the permanent public URL — it can't be changed after creation.",
  "project.err.slugRequired": "The URL can't be empty — pick a short lowercase name",
  "project.err.slugInvalid": "Lowercase letters, digits and hyphens only (2–32 chars, must start/end alphanumeric, no double hyphens)",
  "project.err.slugTaken": "That URL is already taken — try another",
  "project.addScreenshotsNudge": "Add screenshots to complete your page",
  "project.noDescription": "No description yet",
  "project.writeDescription": "Write one →",
  "project.timelineEmpty": "No updates yet",
  "project.timelineEmptyHint": "Build / Show posts will appear here in order",
  "project.discussEmpty": "No discussions yet",
  "project.stageIdea": "Idea",
  "project.stageWIP": "WIP",
  "project.stageShipped": "Shipped",
  "project.stagePaused": "Paused",

  // Thread
  "thread.replyLoginHint": "Sign in to join the discussion",

  // NotFound
  "notFound.title": "This page doesn't exist",
  "notFound.deck": "The address may be mistyped, or the page has moved.",
  "notFound.backHome": "Back home →",

  // Email verification
  "verify.banner": "Your email is unverified — posting is disabled.",
  "verify.resend": "Resend verification email",
  "verify.resent": "Sent (check your inbox and spam)",
  "verify.label": "EMAIL VERIFICATION",
  "verify.pending": "Verifying…",
  "verify.ok": "Email verified. All features unlocked.",
  "verify.goHome": "Back home",
  "verify.fail": "Link invalid or expired.",
  "verify.failHint": "Log in and use the top banner to resend (links last 24 hours).",

  // Password reset
  "login.forgot": "Forgot password?",
  "reset.sent": "If that email exists, a reset link is on its way (valid for 1 hour).",
  "reset.label": "RESET PASSWORD",
  "reset.hint": "Choose a new password (8+ characters).",
  "reset.placeholder": "New password",
  "reset.submit": "Reset and sign out everywhere",
  "reset.ok": "Password reset. All old sessions are signed out.",
  "reset.goLogin": "Go to login",
  "reset.fail": "Link invalid or expired.",
  "reset.failHint": "Use “Forgot password” on the login page to get a fresh link (valid 1 hour).",

  // Waitlist
  "waitlist.prompt": "No invite? Leave your email and we'll write when registration opens.",
  "waitlist.placeholder": "Your email",
  "waitlist.submit": "Join waitlist",
  "waitlist.done": "You're on the list. We'll email you when it opens.",
  "waitlist.invalidEmail": "Enter a valid email address",
};

export default common;